var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"progressbar":"","aria-live":"assertive"}},[_c('div',{attrs:{"data-bar":""}},[_c('span',{style:({ 
                width: `${_vm.progressPercentage}%`
            }),attrs:{"data-value-label":""}},[_c('span',{attrs:{"data-only-screenreader":""}},[_vm._v(_vm._s(this.$store.getters.textResource(`rs_progress`)))]),(_vm.layout.ProgressBar.ShowProgressTopPublicName === 'WithPercentage')?_c('p',{attrs:{"data-progress-percentage":""}},[_vm._v(_vm._s(_vm.progressPercentage)+"%")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }